import { Button, DataSource, Layout, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlCredentials extends Layout {
    buttonViewUser: Button;
    sourceContacts: DataSource;
    switchIsActive: Switch;
    switchPrimaryContact: Switch;
    switchWebAccess: Switch;
    tabContactData: Tab;
    tabsetContact: Tabset;
    textboxEmail: Textbox;
    textboxLoginId: Textbox;
    textboxName: Textbox;
    textboxWebPassword: Textbox;
    textboxWebUserId: Textbox;
}
